import * as React from 'react'
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import RateMarkUpModal from "./RateMarkUpModal";
import {IOSSwitch} from "../../components/CustomUIComp/CustomSwitch";
import {injectIntl, IntlShape} from 'react-intl'

interface IProps {
    exchangeFlag: number,
    feeType: number,
    markupRate: number,
    handleFeeTypeChange: () => void,
    saveMarkupRate: (value: string) => void,
    intl: IntlShape
}

interface IState {
    open: boolean,
    markupRate: string,
    rateError: string
}


class PaymentSettings extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: false,
            markupRate: String(props.markupRate * 100),
            rateError: ''
        }
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    onOpen = () => {
        this.setState({
            open: true
        })
    }
    handleMarkUpRateChange = (e: any) => {
        this.setState({
            markupRate: e.target.value
        })
    }
    saveMarkUpRate = () => {
        let rate = Number(this.state.markupRate)
        if(isNaN(rate)){
            this.setState({
                rateError: '必須為數字'
            })
            return
        }
        this.props.saveMarkupRate(this.state.markupRate)
    }
    public render() {
        let {intl} = this.props
        return (
            <div className="section-settings">
                <h3>{intl.formatMessage({id: 'paymentSettings'})}</h3>
                <div className="content clear">
                    <div className="info">
                        <label>{intl.formatMessage({id: 'userBuyFee'})}:</label>
                        <IOSSwitch
                            checked={this.props.feeType ? true : false}
                            onChange={this.props.handleFeeTypeChange}
                        />
                    </div>
                    {this.props.exchangeFlag ?
                    <div className="info">
                        <label>{intl.formatMessage({id: 'markupRate'})}:</label>
                        <span>{this.props.markupRate * 100}%</span>
                        <button className="changeMarkupRateBtn" onClick={this.onOpen}>{intl.formatMessage({id: 'modify'})}</button>
                    </div> : null}
                </div>
                <CustomDialog open={this.state.open}
                              title={intl.formatMessage({id: 'modifyRate'})}
                              showActions={false}
                              handleClose={this.handleClose}
                              content={<RateMarkUpModal
                                  error={this.state.rateError}
                                  markupRate={this.state.markupRate}
                                  handleMarkUpRateChange={this.handleMarkUpRateChange}
                                  onConfirm={this.saveMarkUpRate}
                                  onClose={this.handleClose}/>}
                            />
            </div>
        );
    }
}

export default injectIntl(PaymentSettings)
